export default {
    state: {
        error: null,
        breadcrumbs: [],
        isLogin: localStorage.getItem('is_login_'+process.env.VUE_APP_VERSION) === 'true',
        userId: localStorage.getItem('user_id_'+process.env.VUE_APP_VERSION) ? parseInt(localStorage.getItem('user_id_'+process.env.VUE_APP_VERSION)) : null,
        users: [
            {
                id: 1,
                login: 'magvan',
                password: 'mmc1990',
                permissions: ['cam_elevator', 'cam_street']
            },
            {
                id: 2,
                login: 'guest',
                password: 'dom123456',
                permissions: ['cam_street']
            }
        ]
    },
    mutations: {
        setError(state, payload) {
            state.error = payload
        },
        clearError(state) {
            state.error = null
        },
        setBreadcrumbs(state, payload) {
            state.breadcrumbs = payload
        }
    },
    actions: {
        setError({commit}, payload) {
            commit('setError', payload);
        },
        clearError({commit}) {
            commit('clearError');
        }
    },
    getters: {
        error(state) {
            return state.error;
        },
        breadcrumbs(state) {
            return state.breadcrumbs;
        }
    }
}